import { render, staticRenderFns } from "./dtlResource.vue?vue&type=template&id=da1ab9d0&scoped=true&"
import script from "./dtlResource.vue?vue&type=script&lang=js&"
export * from "./dtlResource.vue?vue&type=script&lang=js&"
import style0 from "./dtlResource.vue?vue&type=style&index=0&id=da1ab9d0&prod&lang=css&"
import style1 from "./dtlResource.vue?vue&type=style&index=1&id=da1ab9d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1ab9d0",
  null
  
)

export default component.exports